export const BASE_URL = '/invest-online-asset-management/api/';
